import { render } from "./TotalBox.vue?vue&type=template&id=6553ec46&scoped=true&ts=true"
import script from "./TotalBox.vue?vue&type=script&lang=ts"
export * from "./TotalBox.vue?vue&type=script&lang=ts"

import "./TotalBox.vue?vue&type=style&index=0&id=6553ec46&scoped=true&lang=scss"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6553ec46"]])

export default __exports__